import { useEffect, useMemo, useReducer } from 'react'
import { reducer, init } from '../../state'
import { useAppSelector } from '@user/store/hooks'
import { selectCurrentUser } from '@user/store/authorization'
import { selectAllFilterPreferences } from '@user/store/userPreferences'
import { deserializeFilters, normalizeFilters } from '@user/components/Filters'
import { ActivitySummaryDTO, ActivitySummaryFilterSet } from '../../typings'
import { clearedFilters } from '../../constants'

export function useData() {
  const currentUser = useAppSelector(selectCurrentUser)
  const preferences = useAppSelector(selectAllFilterPreferences)

  const savedFilters = useMemo(
    () => preferences.find((p) => p.type === 'activitySummary'),
    [preferences],
  )

  const value = useReducer(reducer, { currentUser, savedFilters }, init)
  const [, dispatch] = value

  useEffect(() => {
    if (!savedFilters) {
      return
    }
    const loadedFilters = deserializeFilters<
      ActivitySummaryDTO,
      ActivitySummaryFilterSet
    >(clearedFilters, savedFilters?.filter || '')

    const filterSet = normalizeFilters<
      ActivitySummaryDTO,
      ActivitySummaryFilterSet
    >(loadedFilters)

    dispatch({
      type: 'activitySummary/setFilters',
      payload: filterSet,
    })
  }, [savedFilters?.filter, dispatch])

  return { value }
}
